// extracted by mini-css-extract-plugin
export var contactSection = "contacts-module--contactSection--YM9SC";
export var contactsIcon = "contacts-module--contactsIcon--6qmfE";
export var socialContainer = "contacts-module--socialContainer--rcMzc";
export var formAndMapsSection = "contacts-module--formAndMapsSection--oQSd-";
export var contactsForm = "contacts-module--contactsForm--xLLhp";
export var emailMessage = "contacts-module--emailMessage--9JhKw";
export var fadein = "contacts-module--fadein--8GG5B";